import Icon from '@components/Icon';
import { CompanionsIcon } from '@components/Icons/CompanionsIcon';
import { useTranslation } from 'react-i18next';
import { SerenityIcon } from '../Icons/SerenityIcon';
import { WisdomIcon } from '../Icons/WisdomIcon';

interface CategoryBadgeProps {
  category: 'music' | 'serenity' | 'audiobooks' | 'companion';
  label?: string;
}

export const CategoryBadge = ({ category, label }: CategoryBadgeProps) => {
  const { t } = useTranslation();
  // Default labels
  const defaultLabels = {
    music: t('badge.music'),
    serenity: t('badge.serenity'),
    audiobooks: t('badge.audiobooks'),
    companion: t('badge.companion'),
  };

  const displayLabel = label || defaultLabels[category];
  // const iconName =
  //   category === 'audiobooks'
  //     ? 'audiobooks'
  //     : category === 'serenity'
  //     ? 'serenity'
  //     : 'track';

  // Use pl-[12px] for audiobooks, pl-[8px] for others
  const paddingLeft = category === 'audiobooks' ? 'pl-[12px]' : 'pl-[8px]';

  return (
    <div
      className={`absolute top-[20px] left-[20px] z-[9999] flex items-center justify-center bg-black/40 rounded-full h-[40px] gap-[5px] opacity-100 py-[4px] pr-[12px] ${paddingLeft}`}>
      <span className="text-white">
        {category === 'audiobooks' && <WisdomIcon />}

        {category === 'serenity' && <SerenityIcon />}

        {category === 'companion' && <CompanionsIcon width={20} height={20} />}

        {category === 'music' && <Icon name="track" color="white" size={20} />}
      </span>
      <span className="text-white text-[12px] md:text-[14px] font-[500] leading-[100%] whitespace-nowrap">
        {displayLabel}
      </span>
    </div>
  );
};
